import React from 'react';

import { Link, useLocation } from 'react-router-dom';

import classes from 'components/common/ErrorPages/ErrorPages.module.scss';

export const PageNotFoundMobile = () => {
    const location = useLocation();

    const pathContainsMobile = location.pathname.includes('mobile');

    return (
        <div className={classes.message}>
            <div className={classes.description}>
                <h1>Sorry, Page/Item Not Found</h1>
                {!pathContainsMobile && (
                    <h2 className={classes.mobile}>
                        This page is not supported on the mobile site. Please login on desktop with the same link.
                    </h2>
                )}
            </div>
            <div>
                <Link to={'/'}>Go to homepage</Link>
            </div>
        </div>
    );
};
